import React from 'react';

import Flag from '@atlaskit/flag';

const FlagDefaultExample = (): React.JSX.Element => {
	return (
		<Flag
			title="New version published"
			description="Scott Farquhar published a new version of this page. Refresh to see the changes."
			id="new-version"
		/>
	);
};

export default FlagDefaultExample;
